/** @format */

import * as React from 'react';

export const IconGeneralServices = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 20.0009V18.0018C22.9964 15.2604 21.9692 12.619 20.1196 10.5948C18.27 8.57056 15.7311 7.30924 13 7.05776V5.73036C13.3813 5.51033 13.6793 5.17069 13.8478 4.76412C14.0162 4.35754 14.0458 3.90677 13.9319 3.48169C13.8179 3.05662 13.5668 2.681 13.2175 2.41311C12.8682 2.14521 12.4403 2 12 2C11.5597 2 11.1318 2.14521 10.7825 2.41311C10.4332 2.681 10.1821 3.05662 10.0681 3.48169C9.9542 3.90677 9.98376 4.35754 10.1522 4.76412C10.3207 5.17069 10.6187 5.51033 11 5.73036V7.05776C8.26889 7.30924 5.73002 8.57056 3.88041 10.5948C2.0308 12.619 1.00363 15.2604 1 18.0018V20.0009C0.734784 20.0009 0.48043 20.1062 0.292893 20.2937C0.105357 20.4811 0 20.7354 0 21.0005C0 21.2655 0.105357 21.5198 0.292893 21.7072C0.48043 21.8947 0.734784 22 1 22H23C23.2652 22 23.5196 21.8947 23.7071 21.7072C23.8946 21.5198 24 21.2655 24 21.0005C24 20.7354 23.8946 20.4811 23.7071 20.2937C23.5196 20.1062 23.2652 20.0009 23 20.0009ZM3 18.0018C3.473 6.07321 20.531 6.0822 21 18.0018V20.0009H3V18.0018Z"
        fill="#313140"
      />
    </svg>
  );
};
